export class Organisation {
    accountOrganisationId: string;
    publicId: string;
    accountId: string;
    name: string;
    locationSuburb: string;
    locationPostCode: number;
    jobTitle: string;
    otherJobTitle: string;
    email: string;
    extOrganisationId: string;
    externalId: number;
    isMain: boolean;
    fromDate: Date;
    toDate: Date;
    statusCode: string;
    roleCode: string;
    dioceseId: number;
    isDioceseOffice: boolean;
    // some position has a fixed role in the organisation, therefore this next property indicates if the user can change the person's role in the organisation or not
    isRoleCodeAlterable: boolean;
}





// WEBPACK FOOTER //
// ./src/app/models/organisation.ts